import { useEffect, useState } from 'react';

// BE status → i18n key.
export const EXPECTED_PAY_STATUS_I18N = {
  unpaid: 'employeeLeave_expectedPay_unpaid',
  missing_base_wage: 'employeeLeave_expectedPay_missingBaseWage',
  missing_shift_wage: 'employeeLeave_expectedPay_missingShiftWage',
  unavailable: 'expectedPayUnavailable'
};

export const useExpectedLeavePay = ({
  accountContractV2LeaveId,
  startDate,
  endDate,
  durationHours,
  wageSource,
  includeShiftPayrollFields,
  shiftId,
  unbookingId,
  branchId,
  fetchExpectedPay
}) => {
  const [preview, setPreview] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (!accountContractV2LeaveId || !startDate || !endDate) {
      setPreview(null);
      return undefined;
    }
    let cancelled = false;
    setLoading(true);
    fetchExpectedPay({
      accountContractV2LeaveId,
      startDate,
      endDate,
      durationHours,
      wageSource,
      includeShiftPayrollFields,
      shiftId,
      unbookingId,
      branchId
    })
      .then((res) => {
        if (!cancelled) setPreview(res?.data || null);
      })
      .catch(() => {
        if (!cancelled) setPreview(null);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });
    return () => {
      cancelled = true;
    };
  }, [
    accountContractV2LeaveId,
    startDate,
    endDate,
    durationHours,
    wageSource,
    includeShiftPayrollFields,
    shiftId,
    unbookingId,
    branchId,
    fetchExpectedPay
  ]);

  const hasInputs = !!accountContractV2LeaveId && !!startDate && !!endDate;
  let statusKey = null;
  if (loading || !hasInputs) statusKey = null;
  else if (!preview) statusKey = 'unavailable';
  else if (preview.status && preview.status !== 'ok') statusKey = preview.status;

  return { preview, loading, statusKey, hasInputs };
};
